import { html, LitElement } from 'lit';
export class DataTableFooter extends LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.role = 'rowgroup';
        this.slot = 'footer';
    }
    render() {
        return html `
      <slot></slot>
    `;
    }
}
//# sourceMappingURL=data-table-footer.js.map